<div>
    <p class="banner">We are taking time out for maintenance. We will be back soon.</p>
</div>

